<template>
  <div class="hotel">
    <div class="hotel__image">
      <Thumbnail
        :id="hotel.code"
        :first-sub-gallery-id="hotel.firstSubGalleryId()"
        :thumbnail="hotel.defaultImage"
        :has-icon="hotel.hasGallery()"
        :triggerAttributes="triggerAttributes"
        :nearByHotelsExpanded="nearByHotelsExpanded"
      />
    </div>
    <div class="hotel__content">
      <div class="row hotel_header">
        <div class="hotel__name col-8">
          <h2 class="hotel__title">{{ hotel.name }}</h2>
        </div>
        <div class="col-4">
          <div class="logo-brand" :class="hotel.brandCode"></div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 d-flex">
          <i class="icon-pin xs mr-2"></i>
          <small class="hotel__distance">
            <a
              class="hotel__distance-link"
              :href="`${hotel.contactURL}#entity-map`"
              target="_blank"
              rel="noopener noreferrer"
              >{{ hotel.jsonHotel().distance | distanceFromDownTown }}</a
            >
          </small>
        </div>
      </div>
      <div class="hotel__bottom">
        <div
          v-if="hotel.jsonHotel().rating && hotel.jsonHotel().rating.reviewCount > 0"
          class="hotel__tripadvisor"
        >
          <img class="hotel__rating" :src="ratingImage" alt="Trip advisor rating" />
          <span class="hotel__reviews">{{
            translate(
              'rdReviews',
              hotel.jsonHotel().rating.reviewCount,
              hotel.jsonHotel().rating.reviewCount
            )
          }}</span>
        </div>
        <div class="hotel__cta">
          <button
            class="btn btn-secondary text-uppercase cta-no-availability hotel__button"
            @click="$emit('checkAvailability', hotel)"
          >
            {{ translate('rdCheckAvailability') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Hotel from '../../domain/Hotel'
import { getRatingImageForNumber } from '@/infrastructure/Tripadvisor'
import Thumbnail from '../shared/Thumbnail'
import { getHotelGalleryTriggers } from '@/infrastructure/Utils'

export default {
  name: 'NearbyHotelCardComponent',
  components: { Thumbnail },
  props: {
    hotel: {
      type: Hotel
    },
    nearByHotelsExpanded: {
      type: Boolean
    }
  },
  computed: {
    ratingImage: function () {
      return getRatingImageForNumber(this.hotel.jsonHotel().rating.bubbleRating)
    },
    triggerAttributes() {
      return getHotelGalleryTriggers(this.hotel)
    }
  }
}
</script>

<style lang="scss" scoped>
.hotel {
  border: solid 1px #eee;
  background: white;
  @media (min-width: 992px) {
    height: 443px;
  }

  &__image {
    height: fit-content;
    margin-bottom: 15px;
  }

  &__content {
    padding: 1.5rem;
    padding-top: 0;
    @media (min-width: 992px) {
      position: relative;
      max-height: 230px;
      height: 100%;
    }
  }

  &_header {
    margin-bottom: 10px;
  }

  &__title {
    font-size: 1.8rem;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    max-height: 110px;
  }

  &__distance {
    padding-bottom: 6rem;
  }

  &__distance-link {
    font-size: 12px;
    color: black;
    text-decoration: underline;
  }
  &__bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media (min-width: 992px) {
      position: absolute;
      bottom: 0;
      width: 90%;
    }
  }
  &__rating {
    margin-left: -0.5rem;
    max-width: 80px;
  }
  &__reviews {
    font-size: 12px;
  }
  &__button {
    padding: 10px;
    @media (min-width: 992px) {
      padding: 15px;
    }
  }
}
</style>
